import React, { lazy, Suspense, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { policyInfo } from 'app/libs/policyInfo';

const PolicyStatic = ({ componentName, version }) => {
	const Component = useMemo(
		() => lazy(() => import(`../../statics/policy/${componentName}/${componentName}_${version}.js`)),
		[componentName, version],
	);

	return (
		<Suspense fallback={null}>
			<Component />
		</Suspense>
	);
};

function usePolicy() {
	const { pathname, search } = useLocation();
	const { version } = queryString.parse(search);
	const service = pathname.split('/')[2];
	const { componentName, deploy } = policyInfo[service];
	const recentVersion = deploy.map((arr) => arr.ver).reduce((acc, cur) => Math.max(acc, cur), 0);
	const versionNumber = deploy.find((info) => info.ver === (version ? Number(version) : recentVersion))?.versionNumber;

	const policyComponent = (
		<PolicyStatic
			componentName={componentName}
			version={version || recentVersion}
		/>
	);

	return { policyComponent, versionNumber };
}

export default usePolicy;
